import React from "react"
import Contact from "../shared/top/Contact"

const TopContact = () => {
  return <Contact target="one" tel="0278-25-4900" />
}

export default TopContact
